import { Controller } from '@hotwired/stimulus'
import $ from 'jquery'

export default class extends Controller {
  static targets = ['modal', 'row', 'form']

  connect() {
    $(this.modalTarget).on('hide.bs.modal', () => {
      this.reloadForm()
    })
  }

  submit(event) {
    event.preventDefault()
    this.submitForm()
  }

  // private

  reloadForm() {
    const url = this.modalTarget.dataset.editUrl

    fetch(url)
      .then(response => response.json())
      .then(data => {
        this.formTarget.innerHTML = data.html
      })
  }

  submitForm() {
    const form = this.modalTarget.querySelector('form')
    const formData = new FormData(form)
    const url = form.getAttribute('action')

    fetch(url, {
      method: 'POST',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        const success = data.success == true

        if (success) {
          this.hideModal()
          this.updateRow(data.row_html)
          this.flashMessage(data.notice_html)
          $(this.modalTarget).on('hide.bs.modal', () => {
            this.reloadForm()
          })
        } else {
          this.formTarget.innerHTML = data.html
        }
      })
  }

  hideModal() {
    $(this.modalTarget).modal('hide')
  }

  updateRow(rowHTML) {
    this.rowTarget.innerHTML = rowHTML
  }

  flashMessage(messageHTML) {
    document.querySelector('#flash_messages').innerHTML = messageHTML
  }
}
